/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ArrowArcRight': {
    width: 24,
    height: 13,
    viewBox: '0 0 24 13',
    data: '<path pid="0" d="M15.645 9.043h6.5v-6.5" _stroke="#00204D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M1.25 11.688a9.75 9.75 0 0116.644-6.895l3.25 3.25" _stroke="#00204D" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
